var $9703be9d55d8e9c2$exports = {};
$9703be9d55d8e9c2$exports = {
    "breadcrumbs": `Caminho detalhado`
};


export {$9703be9d55d8e9c2$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
